export default {

    dashboardTenantSubtitle: 'Este es el resumen de tu organización.',
    dashboardCurrentScope: 'Alcance actual',
    dashboardNoScope: 'Sin alcance seleccionado',
    dashboardExplore: 'Explora y gestiona tu operación de seguridad desde un solo lugar.',

    dashboardMetricScopes: 'Alcances activos',
    dashboardMetricScopesHint: 'Proyectos en análisis',
    dashboardMetricAssets: 'Activos',
    dashboardMetricAssetsHint: 'Elementos del inventario',
    dashboardMetricControls: 'Controles en seguimiento',
    dashboardMetricControlsHint: 'Controles con plan de tratamiento',
    dashboardMetricScans: 'Escaneos realizados',
    dashboardMetricScansHint: 'Análisis de ciberdiagnóstico ejecutados',

    dashboardQuickAccess: 'Accesos rápidos',
    dashboardLinkAssets: 'Activos',
    dashboardLinkTreatment: 'Plan de tratamiento',
    dashboardLinkNewScan: 'Nuevo escaneo',

    dashboardSuperTitle: 'Panel de Superadmin',
    dashboardSuperSubtitle: 'Resumen general de la plataforma.',
    dashboardMetricTenants: 'Organizaciones',
    dashboardMetricActivePlans: 'Planes activos',
    dashboardMetricPendingRequests: 'Solicitudes pendientes',
    dashboardLinkCompanies: 'Organizaciones',
    dashboardLinkPlans: 'Planes',
    dashboardLinkAddons: 'Add-ons',
    dashboardLinkRequests: 'Solicitudes',
    dashboardLinkQuota: 'Consumo',

};
